import { IonPage, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { StoresContext } from '../../../provider/StoreProvider'

export const RoutePending: React.FC<RouteComponentProps> = observer(({ location, history }) => {
  const { authStore } = useContext(StoresContext)

  useEffect(() => {
    if (authStore.userInfo === null) {
      history.push('/home')
    }
    if (authStore.userInfo != null) {
      history.push(location.pathname)
    }
  }, [authStore.userInfo])

  return (
    <IonPage>
      <IonContent />
    </IonPage>
  )
})
